/* eslint-disable no-unused-vars, max-len */
const { feWp } = window;
const { addAction } = feWp.hooks;

// Function to stop autoplay on the slider object
const stopAutoPlay = ( sliderObj ) => {
  sliderObj.autoplay.stop();
};

const updateProgressBar = ( swiper ) => {
  const progressBarFill = swiper.el.querySelector( '.swiper-pagination-progressbar-fill' );
  const activeSlide = swiper.realIndex + 1;
  const progress = ( ( activeSlide / ( swiper.originalSlideCount ) ) ) * 100;
  if ( progressBarFill ) {
    progressBarFill.style.width = progress + '%';
  }
};

const updateDots = ( swiper ) => {
  const dots = swiper.el.querySelectorAll( '.swiper-pagination-bullet' );
  dots.forEach( dot => {
    dot.addEventListener( 'click', () => {
      stopAutoPlay( swiper );
    } );
  } );
};

// Add new video handler function
const handleSlideVideo = ( swiper ) => {
  const slides = swiper.slides;
  
  // Pause all videos first
  slides.forEach( slide => {
    const video = slide.querySelector( '.e-div--media-wrapper video' );
    if ( video ) {
      video.pause();
      video.currentTime = 0;
    }
  } );

  // Play video in active slide
  const activeSlide = slides[swiper.activeIndex];
  const activeVideo = activeSlide?.querySelector( '.e-div--media-wrapper video' );
  if ( activeVideo ) {
    activeVideo.play().catch( err => console.error( 'Error playing video:', err ) );
  }
};

const addSpanToButtons = ( swiper ) => {
  const nextButton = swiper.el.querySelector( '.swiper-button-next' );
  const prevButton = swiper.el.querySelector( '.swiper-button-prev' );
  
  if ( nextButton && !nextButton.querySelector( 'span' ) ) {
    nextButton.innerHTML = '<span></span>';
  }
  if ( prevButton && !prevButton.querySelector( 'span' ) ) {
    prevButton.innerHTML = '<span></span>';
  }
};

//Enable slide click-to-activate for testimonial slider
const enableSlideClickToActive = ( swiper, el ) => {
  const section = el.closest( '.e-stn--testimonial-card-slider' );
  if ( !section ) return;

  swiper.slides.forEach( ( slide, domIndex ) => {
    if ( slide._b3rgClickToActive ) {
      slide.removeEventListener( 'click', slide._b3rgClickToActive );
    }

    slide._b3rgClickToActive = function( e ) {
      if ( slide.classList.contains( 'swiper-slide-active' ) ) return;
      stopAutoPlay( swiper );

      swiper.slideTo( domIndex );
    };

    slide.addEventListener( 'click', slide._b3rgClickToActive, false );
  } );
};

addAction(
  'b3rg_slider_init',
  'b3rg/slider',
  ( settings, el, swiper ) => {
    const isInfinite = settings.loop;
    const isProgressbar = settings.pagination?.type;
    if ( isInfinite ) {
      swiper.params.supports4k = true;
      swiper.params.longSwipesRatio = 0;
      swiper.params.threshold = 0;
      swiper.params.touchRatio = 0.1;
      swiper.params.autoplay = {
        delay: settings?.autoplay?.delay || 3000,
      };
      if ( isProgressbar ) {
        swiper.params.pagination = {
          el: '.swiper-pagination',
          type: 'custom',
          renderCustom: function ( swiper, current, total ) {
            return '<div class="swiper-pagination-wrpr"><span class="swiper-pagination-progressbar-fill"></span></div><div class="swiper-fraction-custom">' +
              current +
              '/' + ( swiper.originalSlideCount ) + '</div>';
          },
          renderFraction: function () {
            return '';
          }
        };
        el.querySelector( '.swiper-pagination' ).classList.add( 'swiper-pagination-custom' );
        swiper.on( 'slideChange', function () {
          updateProgressBar( this );
        } );
        swiper.on( 'init', function () {
          // Update the progress bar on initialization
          updateProgressBar( this );
        } );
      }
      swiper.update();
    }
    addSpanToButtons( swiper );
    enableSlideClickToActive( swiper, el );
    swiper.on( 'afterInit', ( swiper )=> {
      updateDots( swiper );
    } );
    
    const arrows = swiper.el.querySelectorAll( '.e-sld__btn' );
    arrows.forEach( arrow => {
      arrow.addEventListener( 'click', () => {
        stopAutoPlay( swiper );
      } );
    } );
    swiper.on( 'click', function () {
      stopAutoPlay( swiper );
    } );
    swiper.on( 'touchStart', function () {
      stopAutoPlay( swiper );
    } );
    // Prevent additional swipes during the transition
    swiper.on( 'slideChangeTransitionStart', () => {
      swiper.allowTouchMove = false;
    } );
    // Re-enable touch dragging after the transition
    swiper.on( 'slideChangeTransitionEnd', () => {
      swiper.allowTouchMove = true;
    } );

    // Initialize videos on load
    swiper.on( 'init', () => {
      handleSlideVideo( swiper );
    } );

    // Handle videos on slide change
    swiper.on( 'slideChange', () => {
      handleSlideVideo( swiper );
      enableSlideClickToActive( swiper, el );
    } );
  },
  10,
  1,
);